var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "validation",
      staticClass: "analise card-collapse",
      attrs: { tag: "div" }
    },
    [
      _vm.despachoAtual !== null
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _c(
                "template",
                { slot: "separate" },
                [
                  _c(
                    "el-card",
                    { attrs: { shadow: "hover" } },
                    [
                      _c("app-despachos", {
                        attrs: {
                          idProcesso: _vm.idProcesso,
                          data: _vm.dadosCadastro
                        },
                        on: { getDownload: _vm.getDownload }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("app-pdf-viewer", { attrs: { bytes: _vm.arrayBytes } }),
              _vm.acoesRadio.length
                ? _c(
                    "div",
                    { staticClass: "extra-margin-top" },
                    [
                      _c(
                        "validation-observer",
                        {
                          ref: "validationTitulo",
                          staticClass: "flex-around",
                          attrs: { tag: "div" }
                        },
                        [
                          _c("app-radios-tramitacao", {
                            attrs: {
                              radios: _vm.acoesRadio,
                              isDecisao: _vm.isDecisao,
                              radioInicial: _vm.despachoAtual.acao
                            },
                            on: { changeRadio: _vm.changeRadio }
                          })
                        ],
                        1
                      ),
                      _vm.isRevisao
                        ? _c(
                            "div",
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            staticClass: "input-text-editor",
                                            attrs: { label: "Despacho" }
                                          }),
                                          _c("app-editor-texto", {
                                            ref: "editorTexto",
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            on: {
                                              onTextChange: _vm.onTextChange
                                            },
                                            model: {
                                              value:
                                                _vm.despachoAtual.textoDespacho,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.despachoAtual,
                                                  "textoDespacho",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "despachoAtual.textoDespacho"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  400267599
                                )
                              }),
                              _c("app-anexo", {
                                attrs: {
                                  id: "upload-anexo-despacho",
                                  files: _vm.despachoAtual.documentos,
                                  tipoExibir: "ANEXO_ANALISE"
                                },
                                on: {
                                  uploadFile: _vm.uploadFile,
                                  removeFile: _vm.removeFile,
                                  downloadDocumentoCadastro:
                                    _vm.downloadDocumentoCadastro
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-146d5fd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146d5fd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/oficio/ConfirmarDados.vue
// module id = null
// module chunks = 